import { Action, Dispatch } from 'redux';
import { getCurrentSystemSettings, ISystemSetting } from '../api/vault/systemSettings';
import { SYSTEM_SETTINGS_STORAGE_KEY } from '../constants';
import { IAppState } from './reducers';

export interface IState {
  systemSettings: ISystemSetting;
}

export enum ActionType {
  UpdateSettings = 'SystemSettings.UpdateSettings',
}

export interface ISystemSettingsAction extends Action<ActionType> {
  payload?: any,
}

export const INITIAL_STATE: IState = {
  systemSettings: (() => {
    const stored = localStorage.getItem(SYSTEM_SETTINGS_STORAGE_KEY);
    if (stored && stored !== 'undefined') {
      try {
        return JSON.parse(stored);
      } catch {
        return null;
      }
    }
    return null;
  })(),
};

export default function reducer(state: IState = INITIAL_STATE, action: ISystemSettingsAction): IState {
  switch (action.type) {
    case ActionType.UpdateSettings:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export const getSystemSettings = () => async (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  const settings = (await getCurrentSystemSettings()).data.data;
  dispatch({
    payload: {
      systemSettings: settings,
    },
    type: ActionType.UpdateSettings,
  });
  localStorage.setItem(SYSTEM_SETTINGS_STORAGE_KEY, JSON.stringify(settings));
};
